export default __webpack_public_path__ + "246b2999d5e1c39d678b71b826656dae.png";